// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import pt from 'prop-types';

import { isEmpty as _isEmpty } from 'lodash';

import s from './index.module.scss';
import { MrInlineIconCard } from '@ion/components';
import useGetMetrics from './use-get-metrics';
import formatDeliveryRate from '../table/columns/format-delivery-rate';
import sumMetrics from './sum-metrics';
import inlineCards from './description';
import { formatNumber } from '@ion/mrdash';

const DashboardInlineCards = ({ clusters, pipelines, since, until, metricsData }) => {
  const [{ metrics, loading }] = useGetMetrics({
    clusters,
    pipelines,
    since,
    until,
  });

  const sumEvents = sumMetrics(metricsData);

  return (
    <div className={s.inlineCards}>
      <MrInlineIconCard className={s.inlineCard} {...inlineCards.totalEvents}>
        <div>{!loading && !_isEmpty(metrics) ? formatNumber(metrics?.totalEvents) : '--'}</div>
      </MrInlineIconCard>
      <MrInlineIconCard className={s.inlineCard} {...inlineCards.notDelivered}>
        <div>
          {formatNumber(sumEvents.CONSENT)} / {formatNumber(sumEvents.PLAYBOOK_FILTER)} /{' '}
          {formatNumber(sumEvents.Errors)}{' '}
        </div>
      </MrInlineIconCard>
      <MrInlineIconCard className={s.inlineCard} {...inlineCards.delivered}>
        <div>
          {formatNumber(sumEvents.Success)} ({formatDeliveryRate(sumEvents)})
        </div>
      </MrInlineIconCard>
    </div>
  );
};

DashboardInlineCards.propTypes = {
  clusters: pt.array.isRequired,
  pipelines: pt.array.isRequired,
  since: pt.instanceOf(Date).isRequired,
  until: pt.instanceOf(Date).isRequired,
  metricsData: pt.array.isRequired,
};

export default DashboardInlineCards;
